import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ModalController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import { LikesPage } from 'src/app/pages/likes/likes.page';
import { LikesService } from '@shared/services/likes.service';
import { PurchaseService } from 'src/app/services/purchase.service';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'app-new-likes-icon', 
  templateUrl: './new-likes-icon.component.html',
  styleUrls: ['./new-likes-icon.component.scss'],
})
export class NewLikesIconComponent  implements OnInit , OnDestroy {

  @Input() unregisterFunction: Function | any;
  @Input() refreshMyData?:  () => void; 
  @Input() vegBoostEnable: boolean = false;

  public canSeeWhoLikedMe: boolean = false;
  public newLikes: number = 0;
  public totalLikedBy: number = 0;
  private me: any;

  private userDataSub: Subscription | undefined;

  constructor(
    public modalCtrl: ModalController,
    private purchaseServiceProvider: PurchaseService,
    private userDataService: LikesService,
    public userService: UserService 
  ) { }

  ngOnInit() {
    this.userDataSub = this.userDataService.userData$.subscribe((userData) => {
      this.me = userData;
      this.refreshLikeInfo();
    });
  }

  ngOnDestroy() {
    // Não se esqueça de cancelar a inscrição para evitar memory leaks
    if (this.userDataSub) {
      this.userDataSub.unsubscribe();
    }
  }

  async openLikedProfiles() {    
    if (this.unregisterFunction) this.unregisterFunction.unsubscribe();

    const modal = await this.modalCtrl.create({
      component: LikesPage,
      componentProps: {
        refreshMyData: this.refreshMyData,
        vegBoostEnable: this.vegBoostEnable,
      },
    });

    //Reload Likes when modal is dismissed
    modal.onDidDismiss().then(() => {
      if(this.refreshMyData){
        this.refreshMyData();

      // In case we don't have an explicity refreshMyData function.
      } else{
            var theObs: Observable<any>;
            theObs = this.userService.refreshMyData(this.me, true /*getDeletedLikes*/);
            theObs.subscribe(async data => {
              if (data == '{not ok}') {
                console.log('Refresh my data failed..');
                return;
              }
              console.log(JSON.stringify(data));
              this.me = JSON.parse(data);

              Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.me) }).then((val) => {})

            },
              err => {
                console.log('Error refreshing me: ' + err.toString());
              })
      }
      this.refreshLikeInfo();
    });

    modal.present();
  }

  private refreshLikeInfo(){
    // Check if the user can see who liked him
    this.canSeeWhoLikedMe = this.purchaseServiceProvider.canSeeWhoLikedMe(this.me);

    // Determine total received likes
    const likedBySouls = this.me?.likedBySouls ?? [];
    this.totalLikedBy = likedBySouls.length;
  
    // Check How many new likes do we have
    const lastSeenLikedByQuant = this.me?.lastSeenLikedByQuant ?? 0;
    
    if(this.canSeeWhoLikedMe){
      this.newLikes = this.totalLikedBy - lastSeenLikedByQuant; 
    }
    else{
      this.newLikes = this.totalLikedBy - lastSeenLikedByQuant - (this.me?.deletedLikes ?? 0); 
    }
  }
}